import { Injectable } from '../../helpers';

export class TinyMceService extends Injectable {

    static get $inject() {

        return [
            'ImageUploadPmsApiService'
        ];
    }

    settings($translate) {

        const editorLang = $translate.use() === 'en' ? 'en' : 'ar';
        const editorLangUrl = $translate.use() === 'ar' ? require('../helpers/langs/ar.js') : '';

        return dir => ({
                directionality: dir,
                language: editorLang,
                language_url: editorLangUrl,
                menubar: false,
                statusbar: true,
                height: 200,
                resize: true,
                plugins: 'link image code lists',
                toolbar: 'bold italic underline | bullist numlist outdent indent | code link image',
                images_upload_url: true,
                images_upload_handler: (blobInfo, success, failure) => {

                    this.ImageUploadPmsApiService
                            .tinyMCEUpload(blobInfo)
                            .then((response) => {

                                success(response.data[0]);
                            }, (response) => {

                                failure($translate.instant(response.data['images.0'][0]));
                            });
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/tinyMce.service.js